/**
 * Client Lazy Imports - Used during client builds (React.lazy for code-splitting)
 * This file is resolved via the '@/route-pages' alias in vite.config.ts for client/dev builds.
 */
import { lazy } from 'react';

// Core pages
export const Index = lazy(() => import('@/pages/Index'));
export const Blog = lazy(() => import('@/pages/Blog'));
export const BlogPost = lazy(() => import('@/pages/BlogPost'));
export const Dealers = lazy(() => import('@/pages/Dealers'));
export const DealerDetail = lazy(() => import('@/pages/DealerDetail'));
export const DealersByCity = lazy(() => import('@/pages/DealersByCity'));
export const Alerts = lazy(() => import('@/pages/Alerts'));
export const ComproOroCitta = lazy(() => import('@/pages/ComproOroCitta'));
export const ComproOroRoma = lazy(() => import('@/pages/ComproOroRoma'));
export const ComproOroRomaTuscolana = lazy(() => import('@/pages/ComproOroRomaTuscolana'));
export const ComproOroRomaSanGiovanni = lazy(() => import('@/pages/ComproOroRomaSanGiovanni'));
export const ComproOroRomaCentroStorico = lazy(() => import('@/pages/ComproOroRomaCentroStorico'));
export const ComproOroRomaMonteverde = lazy(() => import('@/pages/ComproOroRomaMonteverde'));
export const ComproOroRomaPrati = lazy(() => import('@/pages/ComproOroRomaPrati'));
export const ComproOroRomaAppiaNuova = lazy(() => import('@/pages/ComproOroRomaAppiaNuova'));
export const ServerPredictionsPage = lazy(() => import('@/pages/ServerPredictionsPage'));

// Legal pages
export const Contatti = lazy(() => import('@/pages/Contatti'));
export const ChiSiamo = lazy(() => import('@/pages/ChiSiamo'));
export const Privacy = lazy(() => import('@/pages/Privacy'));
export const Termini = lazy(() => import('@/pages/Termini'));
export const CookiePolicy = lazy(() => import('@/pages/CookiePolicy'));

// Other SSR-safe pages
export const Gildy = lazy(() => import('@/pages/Gildy'));
export const Faq = lazy(() => import('@/pages/Faq'));
export const Charts = lazy(() => import('@/pages/Charts'));
export const QuotazioneDiamanti = lazy(() => import('@/pages/QuotazioneDiamanti'));
export const CalcolatoreCaratiDiamante = lazy(() => import('@/pages/CalcolatoreCaratiDiamante'));
export const RegistrazioneAttivita = lazy(() => import('@/pages/RegistrazioneAttivita'));
export const MoneteOroInvestimento = lazy(() => import('@/pages/MoneteOroInvestimento').then(m => ({ default: m.MoneteOroInvestimento })));
export const ServerLingottiOroInvestimentoPage = lazy(() => import('@/pages/ServerLingottiOroInvestimentoPage').then(m => ({ default: m.ServerLingottiOroInvestimentoPage })));

// Detail pages
export const CoinDetailPage = lazy(() => import('@/pages/CoinDetailPage').then(m => ({ default: m.CoinDetailPage })));
export const ServerBarDetailPage = lazy(() => import('@/pages/ServerBarDetailPage').then(m => ({ default: m.ServerBarDetailPage })));

// Diamond pages
export const Le4CDelDiamante = lazy(() => import('@/pages/Le4CDelDiamante'));
export const Diamanti = lazy(() => import('@/pages/Diamanti'));

// Oro investimento hub
export const OroInvestimento = lazy(() => import('@/pages/OroInvestimento').then(m => ({ default: m.OroInvestimento })));

// Vault
export const VaultPage = lazy(() => import('@/pages/VaultPage'));

// Milano landing page
export const ComproOroMilano = lazy(() => import('@/pages/ComproOroMilano'));

// Firenze landing page
export const ComproOroFirenze = lazy(() => import('@/pages/ComproOroFirenze'));
export const ComproOroBari = lazy(() => import('@/pages/ComproOroBari'));
export const ComproOroNapoli = lazy(() => import('@/pages/ComproOroNapoli'));
export const ComproOroTorino = lazy(() => import('@/pages/ComproOroTorino'));
export const ComproOroPalermo = lazy(() => import('@/pages/ComproOroPalermo'));
export const ComproOroGenova = lazy(() => import('@/pages/ComproOroGenova'));
export const ComproOroVerona = lazy(() => import('@/pages/ComproOroVerona'));
export const ComproOroCatania = lazy(() => import('@/pages/ComproOroCatania'));
export const ComproOroPadova = lazy(() => import('@/pages/ComproOroPadova'));
export const ComproOroVenezia = lazy(() => import('@/pages/ComproOroVenezia'));
export const ComproOroCagliari = lazy(() => import('@/pages/ComproOroCagliari'));
export const ComproOroPerugia = lazy(() => import('@/pages/ComproOroPerugia'));
export const ComproOroModena = lazy(() => import('@/pages/ComproOroModena'));
export const ComproOroTrieste = lazy(() => import('@/pages/ComproOroTrieste'));
export const ComproOroVicinoAMe = lazy(() => import('@/pages/ComproOroVicinoAMe'));
export const ComproOroBologna = lazy(() => import('@/pages/ComproOroBologna'));
export const ComproOroPescara = lazy(() => import('@/pages/ComproOroPescara'));
export const PrezzoOroOggi = lazy(() => import('@/pages/PrezzoOroOggi'));
export const PrezzoArgentoOggi = lazy(() => import('@/pages/PrezzoArgentoOggi'));
export const CondizioniDealer = lazy(() => import('@/pages/CondizioniDealer'));
export const VerificaOam = lazy(() => import('@/pages/VerificaOam'));

// Guida cluster
export const GuidaVendereOroUsato = lazy(() => import('@/pages/GuidaVendereOroUsato'));
export const GuidaComproOroComeFunziona = lazy(() => import('@/pages/GuidaComproOroComeFunziona'));
export const GuidaAntiTruffa = lazy(() => import('@/pages/GuidaAntiTruffa'));
export const GuidaDocumentiRicevuta = lazy(() => import('@/pages/GuidaDocumentiRicevuta'));
export const GuidaValoreOroUsato = lazy(() => import('@/pages/GuidaValoreOroUsato'));
export const GuidaVendereOroOnline = lazy(() => import('@/pages/GuidaVendereOroOnline'));
export const Guida10MossePrezzo = lazy(() => import('@/pages/Guida10MossePrezzo'));
export const GuidaNormativaComproOro = lazy(() => import('@/pages/GuidaNormativaComproOro'));
export const GuidaQuotazioneOroUsato = lazy(() => import('@/pages/GuidaQuotazioneOroUsato'));

// Blocca Prezzo Oro landing
export const BloccaPrezzoOro = lazy(() => import('@/pages/BloccaPrezzoOro'));

// Prezzo Oro per Caratura
export const PrezzoOroCaratura = lazy(() => import('@/pages/PrezzoOroCaratura'));

// Prezzo Argento per Purezza
export const PrezzoArgentoPurezza = lazy(() => import('@/pages/PrezzoArgentoPurezza'));

// Pricing Dealer
export const PricingDealer = lazy(() => import('@/pages/PricingDealer'));
